import { differenceInMonths } from 'date-fns';

const getProjectEndDate = (expectedDate, unitPlanDate) => {
    if (expectedDate && unitPlanDate) {
        return expectedDate > unitPlanDate ? expectedDate : unitPlanDate;
    }
    return expectedDate || unitPlanDate || null;
};

export const getProjectTimeline = ({
    zeroDate,
    expectedDate,
    unitPlanDate,
}) => {
    const higherEndDate = getProjectEndDate(expectedDate, unitPlanDate);

    const endYear = higherEndDate
        ? higherEndDate.getFullYear()
        : 0;

    const endMonth = higherEndDate
        ? higherEndDate.getMonth() + 1
        : 12;

    const totalMonth =
        zeroDate && higherEndDate
            ? differenceInMonths(higherEndDate, zeroDate) + 3
            : 0;

    return {
        higherEndDate,
        endYear,
        endMonth,
        totalMonth,
    };
};